import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "resetPasswordSent" }

import { onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Bubble from '../components/Bubble.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordSent',
  setup(__props) {

const i18n = useI18n();
const { t } = i18n;

onMounted(() =>
{
    document.title = t('title');
    watch(i18n.locale, () => { document.title = t('title'); });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Bubble, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_unref(t)('sent')) + " ", 1),
        _createVNode(_component_router_link, {
          to: { name: 'login' },
          class: "continue"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('loginLink')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})